<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_InventSum")
        }}</span>
        <TableMain name="one table" ref="InventSumTable2" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
          :query_button_label="query_lable" :table_height_adjust="-8" :isBusy="isBusy"
          :hb_table_class="'hb_table_is_class1'" @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 0]"
          @current_changed="current_changed" tableref="53399b3b49f8431d8f9d54954765b071">
          <template #query>
            {{ $t("common.invent") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
              v-model="ItemId"></el-input>
            {{ $t("common.search_type") }}：
            <el-select v-model="exportType" style="width: 150px" size="small" :placeholder="$t('common.search_type')"
              @change="changeType" clearable>
              <el-option v-for="item in exportOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            {{ $t("common.company") }}：
            <el-select v-model="Company" style="width: 250px" size="small" :placeholder="$t('common.company')"
              clearable>
              <el-option v-for="item in companyOptions" :key="item.value" :label="item.value + ': ' + item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
          <template #toolbar>
            <el-tooltip content="数据同步" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                  class="iconfont icon-refresh"></i>
              </el-button>
            </el-tooltip>
          </template>
        </TableMain>
        <!-- </BaseContainer> -->
      </el-tab-pane>
      <el-tab-pane label="导入">
        <span slot="label"><i class="iconfont icon-export-in" style="font-size: 14px"></i>&nbsp;{{ $t("tab.tab_import")
        }}</span>
        <InventSumExport></InventSumExport>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TableMain from "../components/table/TableMain"
import InventSumExport from "./InventSumExport"
// -- import * as _ from "lodash-es"
import * as CustTableController from "../../controllers/base/CustTableController"
import * as InventSumController from "../../controllers/wm/InventSumController"

export default {
  name: "InventSum",
  components: {
    TableMain,
    InventSumExport,
  },
  data() {
    return {
      tab_index: 0,
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_invent_sum",
      },
      fields: InventSumController.fields.default,
      rules: InventSumController.rules,
      ItemId: "",
      isBusy: false,
      exportOptions: [
        { value: 0, label: this.$t("common.system") },
        { value: 1, label: this.$t("common.customer") + this.$t("common.import") },
        { value: 2, label: this.$t("common.provider") + this.$t("common.import") },
      ],
      exportType: 0,
      companyOptions: [],
      Company: "",
    }
  },
  created() {
    this.getCompanyOptions()
  },
  methods: {
    async InvokeData() {
      this.msgModal(this.$t("notify.is_continue")).then(async (value) => {
        if (value) {
          // this.isBusy_table1 = true;
          // this.$refs.CustTable1.SetData([]);
          const loading = this.$loading({
            lock: true,
            text: this.$t("notify.in_async"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })

          let _is_wait = true
          setTimeout(() => {
            if (_is_wait) {
              this.msgToasts(this.$t("notify.async_timeout"), "info")
              loading.close()
              _is_wait = false
            }
            return
          }, 30000)

          let _params = {
            company: "070",
            tableName: "secp_InventSum",
            accountNum: "", //不传则查询所有
          }
          await CustTableController.methods.pickAndInvoke(_params)

          loading.close()
          if (_is_wait) {
            this.msgToasts(this.$t("notify.async_success"), "success")
            _is_wait = false
          }
        }
      })
    },
    getCompanyOptions() {
      let company = this.$store.state.biz_data.baseData.CompanyInfo
      this.companyOptions = []
      _.each(company, (t) => {
        this.companyOptions.push({
          value: t.DataArea,
          label: t.CompanyName == null ? "" : t.CompanyName,
        })
      })
      // if (this.companyOptions.length > 0) {
      //   this.Company = this.companyOptions[0].value;
      // }
    },
    changeType() {
      // switch (val) {
      //   case 0:
      //     this.changedataAreaId(0);
      //     break;
      //   case 1:
      //     this.changedataAreaId(1);
      //     break;
      //   case 2:
      //     this.changedataAreaId(2);
      //     break;
      //   default:
      //     break;
      // }
    },
    changedataAreaId(val) {
      let data = _.find(InventSumController.fields.default, {
        key: "dataAreaId",
      })
      if (val == 0) {
        data.label = this.$t("common.company")
      } else if (val == 1) {
        data.label = this.$t("common.customer") + this.$t("common.num")
      } else {
        data.label = this.$t("common.provider") + this.$t("common.num")
      }
    },
    //#region 查询
    async on_query(set_data) {
      this.isBusy = true
      set_data([])
      let _result = await InventSumController.methods.getData({
        ItemId: this.ItemId,
        SourceType: this.exportType,
        Company: this.Company,
      })

      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          if (t.SourceType != 0) {
            t.otherDataAreaId = t.dataAreaId
            t.dataAreaId = ""
            let index = _.findIndex(
              this.$store.state.biz_data.baseData.Customer,
              {
                AccountNum: t.otherDataAreaId,
              }
            )
            if (index > -1) {
              t.CompanyName =
                this.$store.state.biz_data.baseData.Customer[index].SEI_Name
            }
          }
        })
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存

    //#endregion

    current_changed(old, current) {

      this.$emit("current_changed", old, current)
    },
  },
}
</script>
<style>
.hb_table_is_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 130rem;
}
</style>
